import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { Field } from '../../../features/form';
import { hasLejeItem } from '../../../features/commerce/selectors';
import { Div } from '../../../components/grid';
import { FieldComponent, FormWrap, FormIcon } from './FieldForms';
import ExtraPhonenumbersField from './FieldForms/ExtraPhonenumbersField';
import ExtraEmailsField from './FieldForms/ExtraEmailsField';

const ByGrid = styled(Div)`
  display: grid;
  grid-template-columns: 130px 1fr;
  grid-gap: 10px;
`;

const FakturaForm = ({ hasLeje }) => (
  <React.Fragment>
    <FormWrap>
      <Div clear>
        <Field
          component={FieldComponent}
          icon={<FormIcon phone />}
          name="phonenumber"
          formKey="invoice"
          type="text"
          placeholder="Telefonnummer"
          required
          tlf
        />
      </Div>
      {!hasLeje && (
        <Field
          component={FieldComponent}
          icon={<FormIcon hashtag />}
          name="kundenr"
          formKey="invoice"
          type="text"
          placeholder="Evt. kundenr (ikke nødvendig)"
          comment="(Udelad kundenr hvis ny kunde eller du har glemt det)"
          data-recording-gdpr-safe
        />
      )}
      <Field
        component={FieldComponent}
        icon={<FormIcon user />}
        name="name"
        formKey="invoice"
        type="text"
        placeholder="Navn eller firmanavn"
        required
      />
      <Field
        component={FieldComponent}
        icon={<FormIcon userAlt />}
        name="attName"
        formKey="invoice"
        type="text"
        placeholder="Evt. Att. Navn"
      />
      <Field
        component={FieldComponent}
        icon={<FormIcon home />}
        name="address"
        formKey="invoice"
        type="text"
        placeholder="Adresse"
        required
      />
      <ByGrid>
        <Field
          component={FieldComponent}
          icon={<FormIcon city />}
          name="zipCode"
          formKey="invoice"
          type="text"
          placeholder="Postnr."
          required
          postnr
        />
        <Field
          component={FieldComponent}
          name="city"
          formKey="invoice"
          type="text"
          placeholder="By"
          required
          by
        />
      </ByGrid>
      <Field
        component={FieldComponent}
        icon={<FormIcon envelope />}
        name="email"
        formKey="invoice"
        type="text"
        placeholder="Email"
        required
      />
      <Field
        component={FieldComponent}
        name="comment"
        formKey="invoice"
        placeholder="Kommentarfelt | F.eks. særlige ønsker omkring levering."
        textarea
      />
      <Field
        component={ExtraPhonenumbersField}
        name="extraPhonenumbers"
        formKey="invoice"
      />
      <Field
        component={ExtraEmailsField}
        name="extraEmails"
        formKey="invoice"
      />
    </FormWrap>
  </React.Fragment>
);

export default connect(
  state => ({
    hasLeje: hasLejeItem(state),
  }),
)(FakturaForm);
